export enum ViewfinderTypeEnum {
  OPTICAL = "optical",
  ELECTRONIC = "electronic",
  OTHER = "other"
}
